import { useLocation, useNavigate, useParams } from 'react-router-dom'

/** @deprecated Refactor class components into functional components then replace with hooks */
export const withNavigate = (WrappedComponent: any) => {
  return function Component(props: any) {
    const navigate = useNavigate()
    return <WrappedComponent {...props} navigate={navigate} />
  }
}

/** @deprecated Refactor class components into functional components then replace with hooks */
export const withLocation = (WrappedComponent: any) => {
  return function Component(props: any) {
    const location = useLocation()
    return <WrappedComponent {...props} location={location} />
  }
}

/** @deprecated Refactor class components into functional components then replace with hooks */
export const withParams = (WrappedComponent: any) => {
  return function Component(props: any) {
    const params = useParams()
    return <WrappedComponent {...props} params={params} />
  }
}
